import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

const updateZoomMeeting = async ({
  meetingId,
  topic,
  startTime,
  duration,
  timezone,
}: {
  meetingId: string;
  topic: string;
  startTime: string;
  duration: number;
  timezone: string;
}) => {
  const res = await fetchOrchidAPI(
    `/api/users/v1/zoom/update_meeting/${meetingId}`,
    {
      method: "PUT",
      body: JSON.stringify({
        topic,
        start_time: startTime,
        duration,
        timezone,
      }),
    },
  );

  if (!res.ok) {
    const responseText = await res.text();
    throw new Error(getErrorDetail(responseText));
  }

  return;
};

export default updateZoomMeeting;
